
import { Component, Mixins } from 'vue-property-decorator';
import AdvisorStudentPausedCourses from '../../advisorSystem/widgets/StudentPausedCourses.vue';
@Component({})
export default class StudentPausedCourses extends Mixins(AdvisorStudentPausedCourses) {}
